import { createSelector } from 'reselect';

const getMobileState = (state) => state.mobile;

export const mobileSelector = createSelector([getMobileState], (mobile) => mobile);
